import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { NextButtonComponent } from '@hb/modules/global/button';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';
import { PurchasePriceStoreService } from '@hb/modules/property/purchase-price/purchase-price-store.service';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsyncPipe } from '@angular/common';

import { PropertyType } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'purchase-price-amount',
    templateUrl: './purchase-price-amount.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        AsyncPipe,
        ApRadioModule,
        ApAmountInputComponent,
        AdditionalInfoComponent,
        CoApplicantPipe,
        NextButtonComponent
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: PurchasePriceStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.PURCHASE_PRICE_AMOUNT }
    ]
})
export class PurchasePriceAmountComponent extends GlobalInjectComponent<PurchasePriceStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(PurchasePriceStoreService);
    protected readonly propertyType = PropertyType;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getPurchasePrice()?.amount.toString(),
            QuestionKey.PURCHASE_PRICE_AMOUNT
        );
        this.mainApplicantControl.onUpdate().subscribe((amount: string) => {
            this.store.setPurchasePrice(amount);
        });
    }
}
